<template>
	<!-- ����� -->
	<div class="MedicenCata">
		<!--  ����  -->
		<div class="header">
			<div class="header-icon">
				<i class="el-icon-byj"
					style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;background-color: #409EFF;color: #fff;"></i>
				<span style="font-size: 12px;font-weight:400;margin-left: 12px;">ͷ��name</span>
				<div class="feetbtn">
					<el-button v-for="(v,i) in feetBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="small" plain @click="feetHandClick(v)">{{ v.label }}</el-button>
				</div>
			</div>
		</div>
		<!-- �������� -->
		<div class="main">
			<!-- һ������������˵� -->
			<div class="main-left">
				<!-- tree -->
				<el-tree 
				:data="elTree"
				:props="defaultProps"
				node-key="label"
				:default-expanded-keys="['ȫ��']"
				accordion 
				@node-click="handleNodeClick"
				class="custom-tree"
				>
				<span class="custom-tree-node" slot-scope="{ node, data }" style="font-size: 12px;">
					<span :name="node.label">
						<i v-if="!data.children"
						:class="node.expanded ? 'el-icon-openFile' : 'el-icon-closeFiles'"></i>
						<i v-else class="el-icon-openFile"></i>{{ node.label }}
					</span>
				</span>
				</el-tree>
			</div>
			<!-- һ�������Ҳ���� -->
			<div class="main-right">
				<!-- ���������� ���� ʱ��ѡ��ť�¼��� -->
				<div class="main-icon">
					<div class="main-icon-a">
						<i :class="iconComes" style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;;background-color: #5a5a5a;color: #fff;"></i>
						<span style="font-size: 12px;font-weight:bold;margin-left: 12px;color: #606266;">{{ CatalogueName }}</span>
					</div>
					<!-- btn1 -->
					<div class="main-icon-b">
						<span style="font-size: 12px;color: #606266;font-weight: bold;">״̬��</span>
						<el-dropdown @command="handleCommand" trigger="click">
							<span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
							<el-dropdown-menu slot="dropdown">
							  <el-dropdown-item command="a">����</el-dropdown-item>
							  <el-dropdown-item command="b">����</el-dropdown-item>
							  <el-dropdown-item command="c" divided>ȫ��</el-dropdown-item>
							</el-dropdown-menu>
					    </el-dropdown>
					</div>
					<!-- btn2 -->
					<div class="main-icon-c">
						<span style="font-size: 12px;color: #606266;font-weight: bold;display: inline-block;width: 68px;">�ؼ��֣�</span>
						<el-input size="mini" placeholder="���롢���ơ�ƴ������" suffix-icon="el-icon-key" v-model="searchValue"></el-input>
					</div>
					<!-- btn3 -->
					<div class="main-icon-c">
						<el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini" @click="handClick(i)">{{ v.title }}</el-button>
					</div>
				</div>
				<!-- �������� -->
				<!-- ��һ������el-table-column -->
				<!-- Ҳ��ѭ��tableRows -->
				<!-- handleCurrentTableChange Ϊ��ѡ�¼� -->
				<!-- <el-table-column label="��һ��" prop=""></el-table-column> -->
				<!-- <el-table-column label="�ڶ���" prop=""></el-table-column> -->
				<!-- <el-table-column label="..." prop=""></el-table-column> -->
				<div class="table">
					<el-table :data="tableData" border highlight-current-row :style="{ width: windowWidth + 'px' }"
					element-loading-text="���ݼ�����..." v-loading="loading" element-loading-spinner="el-icon-more-outline"
					@current-change="handleCurrentTableChange">
						<el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop" :label="col.name" :width="columnWidth(col, tableData)"></el-table-column>
						<!-- fixed -->
						<el-table-column fixed="left" label="�к�" type="index"></el-table-column>
						<!-- edit -->
						<el-table-column fixed="right" label="����" width="88">
							  <template slot-scope="scope">
								<div class="editbox" style="text-align: center;">
									<el-link type="info" size="mini">�޸�</el-link>
									<el-link type="danger" size="mini">ɾ��</el-link>
								</div>
							  </template>
						</el-table-column>
					</el-table>
				</div>
				<!-- feet -->
				<div class="feet">
					<!-- ��ҳ -->
					<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pageNum"
					:page-sizes="[5, 10, 20]"
					:page-size="pageSize"
					:total="totalSize"
					layout="total, sizes, prev, pager, next, jumper"
					background
					>
					</el-pagination>
					
				</div>
			</div>

		</div>
		<!-- ������Model -->
		<div class="addModel" v-if="addModelShow">
			����������
		</div>
		
	</div>
</template>

<script>
	// selfs / js
	// import addForm from './addForm.js' //Form����
	// import AccType from './AddType.js'
	// �ӿ�
	// import { markUppage,docMark,updatedocMark,deldocMark } from "@/api/systemCatalogue/markUp.js";
	export default {
		components: {
			// MedicenCata
		},
		data() {
			return {
				// ���˵�Props
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				// str
				windowWidth:'', //�Ҳ����̬����
				searchValue:'',
				CatalogueName:'�Ҳ�Main-right Title',
				DropDownedName:'����',
				iconComes:'el-icon-byj',
				// boolean
				disabled:true,
				getdisabled:true,
				loading:false,
				addModelShow:false, // ��������
				// number
				idx: 0,
				pageNum: 1, //��ǰҳcurrentPage
				pageSize: 8,
				totalSize: 10, //������
				/* obj */
				addForm:{}, // form���� ���� * 
				editForm:{}, // form���� �޸� * 
				// arr
				data: [],
				userInfo: [],
				tableData: [],
				currentTable:[],
				TypeOption:[
					{ id:1,label:'��ҩ',value:'��ҩ'},{ id:2,label:'�г�ҩ',value:'�г�ҩ'},
					{ id:3,label:'����',value:'����'},{ id:4,label:'ѪҺ',value:'ѪҺ'},
					{ id:5,label:'����',value:'����'},{ id:9,label:'��ҩ',value:'��ҩ'}
				],
				formType:[], // ����ͷ������
				statusOption:[{ id:0,label:'����',value:'����'},{ id:1,label:'����',value:'����'}],
				// title�Ҳఴť
				headerBtn:[
				 { refesh:"refesh", title:"ˢ��", type:"", icon:"el-icon-refresh" },
				 { senior:"senior", title:"�߼�", type:"primary", icon:"" },
				],
				feetBtn:[
				 // { refesh:"refesh", label:"����", type:"primary", icon:"el-icon-edit" },
				 // { refesh:"refesh", label:"�޸�", type:"primary", icon:"el-icon-finished" },
				 // { refesh:"refesh", label:"ɾ��", type:"primary", icon:"el-icon-document-checked" },
				 // { refesh:"refesh", label:"�鿴", type:"primary", icon:"el-icon-sort" },
				 // { refesh:"refesh", label:"��ӡ", type:"primary", icon:"el-icon-printer" },
				 // { refesh:"refesh", label:"����", type:"primary", icon:"el-icon-finished" },
				 // { refesh:"refesh", label:"�ر�", type:"primary", icon:"el-icon-close" },
				 ],
				// title�Ҳఴť
				tableRows:[
					{ name:"��������", prop:"drugType", type:""},{ name:"�۸�����", prop:"pricLmtTop", type:"" },{ name:"�۸�����", prop:"pricLmtLow", type:"" },
					{ name:"�ӳɷ�ʽ", prop:"status", type:"" },{ name:"�ӳ���", prop:"markUpRate", type:"" },
					{ name:"�Ӽ۽��", prop:"markUpPric", nz:"nz" },{ name:"����ʱ��", prop:"createTime", type:"" },
					{ name:"������", prop:"createId", nz:"nz" },{ name:"��Ч״̬", prop:"state", type:"" },
					{ name:"��ע", prop:"remark", type:"" },
				],
				// ������֤����
				addFormRules:{},
				elTree:[
					{ label: 'ȫ��', path:'', title:'', icon:'el-icon-news',
						children:[
							{ id:1,label: '��ҩ',path:'',title:'��ҩ',icon:'el-icon-xy'},
							{ id:2,label: '�г�ҩ',path:'',title:'�г�ҩ',icon:'el-icon-zhongchengyao'},
							{ id:3,label: '�в�ҩ',path:'',title:'�в�ҩ',icon:'el-icon-zhongcaoyao'},
							{ id:4,label: '����ҩ',path:'',title:'����ҩ',icon:'el-icon-xyzp'},
							{ id:5,label: '����',path:'',title:'����',icon:'el-icon-xyjhtxyyzhy'},
							{ id:6,label: 'ѪҺ',path:'',title:'ѪҺ',icon:'el-icon-blood'},
							{ id:7,label: '����',path:'',title:'����',icon:'el-icon-yimiaoke'},
							{ id:8,label: '�����Լ�',path:'',title:'�����Լ�',icon:'el-icon-tjxg'},
							{ id:9,label: 'Ӫ��',path:'',title:'Ӫ��',icon:'el-icon-cnyyyy'},
						],
					},
				],
			};
		},
		mounted() {
			this.loadData();
			this.getForm();
			//��ȡ��̬���ӿ��ȣ�ʵʱ��ֵ���Ҳ� => this.$refs.mainRight.offsetWidth;
			this.$nextTick(()=>{
				this.updateWindowWidth();
				window.addEventListener('resize', this.updateWindowWidth);
			})
			// ����������Դ
			// this.formType = AccType.map(function(val) { return val })
		},
		methods: {
			/*
				����Դ
			*/
			loadData(){
				
			},
			// ���ػ�����ǰ�����¸�ֵ��˲���
			getForm(){
				// ����ύ����
				// this.addForm = addForm.map(v => {return v })[0]; // Form
				// this.editForm = addForm.map(v => {return v })[0]; // Form
				// �⹹��ֵ�ų� list ���� => ����
				// this.addHeadrForm = addForm.map(item => { let { list, ...newItem } = item; return newItem })[0];
				this.$handlePermissions(); // ����ȫ���Զ����װ����
			},
			/*
				about tree
			*/
			handleNodeClick(data,e) {
				this.CatalogueName = data.title
				this.iconComes = 'el-icon-' + this.makePy(data.label)
				console.log(this.iconComes);
				this.loadData();
			},
			// add
			addSubmit(){

			},
			// editSubmit
			async editSubmit(){
				//������֤����
				this.$refs.editForm.validate(async(valid) => {
				  if(valid){
					//��֤ͨ��
					console.log(this.editForm);
					let res = await updatedocMark(this.editForm)
					console.log(res);
					if (res.code === 200){
					this.$message({
						message:res.message,
						type:"success"
					});
					this.editDialogVisible = false
					this.loadData(); //������������
					}else{
					  // ʧ��
					  this.$message({ type: 'error', message: 'fail!'});
					}
				}
				});
			},
			
			/*
				about table
			*/
			// ����ͷ���۽��¼� => addForm
			async sname(val,i) {
				// val.id = i;
				this.idx = i;
				// i event
				switch (i) {
					// case 1: 
					// 	if(val === 1){
					// 		this.addForm.markUpPric = ''
					// 		console.log(this.formType)
					// 		// this.disabled = true
					// 	}else{
					// 		this.addForm.markUpRate = '1.0'
					// 	}
					// break;
				}
			},
			// SelectVal to editForm
		    // col ��������˱�ͷ�ֶκ����ƣ�list �Ǳ�������
		    columnWidth(col, list) {
				let prop = col.prop,lab = col.lab;
				let width = 40; // �趨һ����Сֵ
				let maxlenStr = ""; // ��ַ���
				for (let info of list) {
		           if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
		        }
		        width = Math.max(width, len(lab), len(maxlenStr));
		        // �����Դ����ڱ߾�(20px) �Ե�
		        return width + 12; // ������� 12px
		        function len(str) {
		           // ʵ�ʷ��䳤�ȿɸ�����Ҫ���е���
		           let length = 8;
		           for (const char of str + "") {
		             // Ӣ��Сд�ַ� 8px
		             if ("a" <= char && char <= "z") length += 8;
		             // Ӣ�Ĵ�д�ַ� 8px
		             else if ("A" <= char && char <= "Z") length += 8;
		             // �����ַ� 28px
		             else if (char >= "\u4e00" && char <= "\u9fa5") length += 32;
		             // ���� 8px
		             else length += 12;
		           }
		           return length;
		        }
		    },
			// see table
			// ����ײ�ѭ����ť�¼�
			feetHandClick(v){
				// v event
				console.log(v);
				if(v.label == '����'){
					this.addModelShow = true
				}else if(v.label == '�޸�'){
					
				}else{
					
				}
			},
			// input 
			handleClose(done) {
				this.$confirm('ȷ�Ϲرգ�')
				  .then(_ => {
					this.$refs['addForm'].resetFields();
					done();
				  })
				  .catch(_ => {
					
				  });
			},
			// db events
			// ����ѡ
			handleCurrentTableChange(val){
				this.currentTable[0] = val
			},

			// ����
			handClick(i) {
				// i event
				switch (i) {
					case 0:
						// ��������0���߼� => ˢ��
						this.loading = true;
						setTimeout(() => {
							this.loadData();
							this.$message({type:'success',message:'��ˢ��'})
							this.loading = false;		
						}, 1500)
						break;
					case 1:
						// ��������1���߼�
						this.$confirm('�����ڴ�')
							.then(_ => {})
							.catch(_ => {});
						break;
				}
			},
			handleCommand(command) {
			  // console.log(command);
			  // ���� command ִֵ����Ӧ���߼�
			  switch (command) {
				case 'a':
				  // ����a���߼�
				  console.log('ִ��A�߼�');
				  this.DropDownedName = '����'
				  break;
				case 'b':
				  // ����b���߼�
				  console.log('ִ��B�߼�');
				  this.DropDownedName = '����'
				  break;
				case 'c':
				  // ����b���߼�
				  this.DropDownedName = 'ȫ��'
				  break;
				// ... ���� case
			  }
			},
			// ʵʱ����
			updateWindowWidth() {
				this.windowWidth = window.innerWidth - 328;
			},
			//��ҳ
			//ÿҳ�����ı䴥��
			handleSizeChange(val) {
				console.log(`ÿҳ ${val} ��`);
				this.pageNum = val;
			},
			//��ǰ�����ı䴥��
			handleCurrentChange(val) {
				console.log(`��ǰҳ: ${val}`);
				this.pageNum = val;
			},
			
		}
	}
</script>

<style lang="less" scoped>
	// content
	.MedicenCata {
		height: 100%;
		width: 100%;
		// header
		.header {
			display: flex;
			flex-direction: row;
			align-items: center;
			height: 40px;
			background-color: #efefef;
			padding: 4px;

			// justify-content: space-evenly;
			// icon
			.header-icon {
				display: flex;
				align-items: center;
			}
			.feetbtn{
				display: flex;
				justify-content: center;
				margin-left: 12px;
			}
		}

		// main
		.main {
			width: 100%;
			display: flex;
			justify-content: space-between;
			// height: 473px; /* ���ø������ĸ߶� */
			// overflow-y: auto; /* �����ݳ��������߶�ʱ��ʾ��ֱ������ */
			// left
			.main-left {
				/deep/ .el-tree-node__content {
					height: 40px;
					padding-left: 0 !important;
				}
				/deep/ .el-tree-node__label{
					font-size: 12px;
				}
				width: 8%;
				margin-left: 12px;
				background-color: red;
				height: 100%;
			}

			// right
			.main-right {
				flex: 4;
				height: 100%;
				// alert
				.addmessagesBox{
					.tabs{
						/deep/ .el-select>.el-input{
							width: 172px;
						}
						/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
							width: 172px;
						}
						/deep/ .el-form-item__content{
							display: flex;
							
							span{
								font-size: 12px;
							}
						}
						.oneLine{
							width: 524px;
							// background-color: indianred;
						}
					}
					/deep/ .el-dialog__title{
						font-size: 12px;
					}
					/deep/ .el-table{
						font-size: 12px;
					}
				}
				// icon
				.main-icon {
					display: flex;
					align-items: center;
					padding: 12px;
					line-height: 40px;
					.main-icon-a{
						// width: 240px;
						// background-color: #00557f;
					}
					.main-icon-b{
						margin-left: 28px;
						/deep/ .el-dropdown{
							font-size: 12px;
							cursor: pointer;
						}
						/deep/ .el-dropdown:hover {
							font-weight: bold;
							color: #66b1ff;
						}
						/deep/ .el-icon--right{
							// background-color: #66b1ff;
						}
						/deep/ .el-popper[x-placement^=bottom]{
							margin-top: 0;
						}
					}
					// c
					.main-icon-c{
						display: flex;
						margin-left: 28px;
						/deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b]{
							width: 80%;
						}
					}
				}
				// table
				/deep/ .el-table .cell{
					font-size: 12px;
					text-align: center;
				}

				/deep/ .el-table td.el-table__cell div :first-child{
					text-align: center;
				}
				/deep/ .el-table td.el-table__cell div{
					text-align: left;
					overflow: hidden;
					white-space: normal;
					word-break: break-all;
				}
				
				.table{
					
				}
			}
		}
		// addModel
		.addModel{
			margin-left: 12px;
			/deep/ .el-dialog__header{
				padding: 12px;
				line-height: 28px;
				background-color: #007bb0;
			}
			/deep/ .el-dialog__title{
				color: #fff;
				font-size: 12px;
			}
			/deep/ .el-dialog__headerbtn .el-dialog__close{
				color: #fff;
			}
			/deep/ .el-dialog__headerbtn .el-dialog__close:hover{
				background-color: brown;
			}
			/deep/ .el-form-item__label{
				font-size: 12px;
			}
		}
		.editModel{
			/deep/ .el-dialog__header{
				padding: 12px;
				line-height: 28px;
				background-color: #007bb0;
			}
			/deep/ .el-dialog__title{
				color: #fff;
				font-size: 12px;
			}
			/deep/ .el-dialog__headerbtn .el-dialog__close{
				color: #fff;
			}
			/deep/ .el-dialog__headerbtn .el-dialog__close:hover{
				background-color: brown;
			}
			/deep/ .el-form-item__label{
				font-size: 12px;
			}
		}
		// feet
		.feet {
			padding: 12px;
			
		}

	}
</style>